import { NgModule } from '@angular/core';
import { DatexPipe } from './datex.pipe';
import { OrderByPipe } from './orderByPipe.pipe';
import { HundredDelimeterPipe } from './hundredDelimeter.pipe';

@NgModule({
  imports: [],
  declarations: [ DatexPipe, OrderByPipe , HundredDelimeterPipe],
  exports: [ DatexPipe, OrderByPipe , HundredDelimeterPipe],
})

export class PipeModule {

  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/pipe.module.ts